import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login";
import Logout from "@/views/Logout";
import Home from "@/views/Home";
import CheckList from "@/views/CheckList";
import UpdSearch from "@/views/UpdSearch";
import UpdScan from "@/views/UpdScan";
import NotFound from "@/views/NotFound";
import { getItem } from "@/helpers/persistanceStorage";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(VueRouter);

NProgress.configure({
  template:
    '<div class="bar" role="bar">' +
    '<div class="peg"></div>' +
    "</div>" +
    '<div class="progress-logo"><img src="/images/berg_logo.png"></div>',
});

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      guest: true,
    },
  },
  {
    path: "/upd/search",
    name: "UpdSearch",
    component: UpdSearch,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/upd/scan",
    name: "UpdScan",
    component: UpdScan,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/check/list",
    name: "CheckList",
    component: CheckList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
  {
    path: "/404",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (getItem("accessToken") == null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (getItem("accessToken") == null) {
      next();
    } else {
      next({ name: "UpdScan" });
    }
  } else {
    next();
  }
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  setTimeout(() => {
    next();
  }, 1000);
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
